import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-backorder-details-modal',
  templateUrl: './backorder-details-modal.component.html',
  styleUrls: ['./backorder-details-modal.component.css']
})
export class BackorderDetailsModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
